export default "<h1>403</h1>\n<h2>Forbidden</h2>\n<p>This page can't be access.</p>";